import React from "react";
import { Modal } from "react-bootstrap";

import { Button, OnlineLink } from "components";
import { floatWithComma2Normalizer } from "validators";

import styles from "./modal.module.scss";

const BatchHistoryModal = ({
	show,
	onHide,
	list,
	merchantId,
	handleSubmit,
}) => {
	return (
		<Modal
			show={show}
			onHide={onHide}
			centered
			className={`${styles.centeredLabelsModal} `}
		>
			<Modal.Header closeButton className="pb-0">
				<Modal.Title as="h6" className="text-center mb-4 ">
					BATCH #: {list.batchNumber}
				</Modal.Title>
			</Modal.Header>
			<Modal.Body className="d-flex flex-column pt-0">
				<div className={styles.wrappBatchHistoryModal}>
					<div className={styles.wrappMid}>
						<div className={styles.ficoLeft}>
							<p style={{ marginBottom: "0px" }}>MID:</p>
						</div>
						<div className={styles.ficoRigth}>
							<p>{list.mid}</p>
						</div>
					</div>
					<div className={styles.wrappFicoDetails}>
						<div className={styles.ficoLeft}>
							<p>TID:</p>
						</div>
						<div className={styles.ficoRigth}>
							<p>{list.terminalNumber}</p>
						</div>
					</div>
					<div className={styles.wrappFicoDetails}>
						<div className={styles.ficoLeft}>
							<p>Total Amount:</p>
						</div>
						<div className={styles.ficoRigth}>
							<p>
								{floatWithComma2Normalizer(
									list.saleAmount,
									"$",
								)}
							</p>
						</div>
					</div>
					<div className={styles.wrappFicoDetails}>
						<div className={styles.ficoLeft}>
							<p
								style={{
									color: "rgba(255, 255, 255, 0.3)",
								}}
							>
								Visa:
							</p>
						</div>
						<div className={styles.ficoRigth}>
							<p
								style={{
									color: "rgba(255, 255, 255, 0.3)",
								}}
							>
								{floatWithComma2Normalizer(list.visa, "$")}
							</p>
						</div>
					</div>
					<div className={styles.wrappFicoDetails}>
						<div className={styles.ficoLeft}>
							<p
								style={{
									color: "rgba(255, 255, 255, 0.3)",
								}}
							>
								MasterCard:
							</p>
						</div>
						<div className={styles.ficoRigth}>
							<p
								style={{
									color: "rgba(255, 255, 255, 0.3)",
								}}
							>
								{floatWithComma2Normalizer(
									list.masterCard,
									"$",
								)}
							</p>
						</div>
					</div>
					<div className={styles.wrappFicoDetails}>
						<div className={styles.ficoLeft}>
							<p
								style={{
									color: "rgba(255, 255, 255, 0.3)",
								}}
							>
								AMEX:
							</p>
						</div>
						<div className={styles.ficoRigth}>
							<p
								style={{
									color: "rgba(255, 255, 255, 0.3)",
								}}
							>
								{floatWithComma2Normalizer(list.amex, "$")}
							</p>
						</div>
					</div>
					<div
						className={styles.wrappFicoDetails}
						style={{ marginBottom: "10px" }}
					>
						<div className={styles.ficoLeft}>
							<p
								style={{
									color: "rgba(255, 255, 255, 0.3)",
								}}
							>
								Discover:
							</p>
						</div>
						<div className={styles.ficoRigth}>
							<p
								style={{
									color: "rgba(255, 255, 255, 0.3)",
								}}
							>
								{floatWithComma2Normalizer(list.discover, "$")}
							</p>
						</div>
					</div>
					<div className={styles.wrappFicoDetails}>
						<div className={styles.ficoLeft}>
							<p>Total Returns:</p>
						</div>
						<div className={styles.ficoRigth}>
							<p>
								{floatWithComma2Normalizer(
									list.totalReturns,
									"$",
								)}
							</p>
						</div>
					</div>
					<div className={styles.wrappFicoDetails}>
						<div className={styles.ficoLeft}>
							<p>Total Voids:</p>
						</div>
						<div className={styles.ficoRigth}>
							<p>
								{floatWithComma2Normalizer(
									list.totalVoids,
									"$",
								)}
							</p>
						</div>
					</div>
					<div className={`${styles.wrappFicoDetails} mt-4 mb-4`}>
						<div className={styles.ficoLeft}>
							<Button
								value="Transactions"
								as={OnlineLink}
								to={`/merchant/list/info/${merchantId}/batch-history/${list.batchNumber}/transactions-batch`}
								className={styles.transactionsBtn}
								onClick={onHide}
							/>
						</div>
						<div className={styles.ficoRigth}>
							<Button
								value="Download CSV"
								onClick={() => handleSubmit()}
								className={styles.downloadBtn}
							/>
						</div>
					</div>
				</div>
			</Modal.Body>
		</Modal>
	);
};

export default BatchHistoryModal;
